import React, { useState, useEffect, useRef } from 'react';
import { Fab } from '@mui/material';
import { ArrowBackIosNew } from '@mui/icons-material';

export const ScrollToTopButton = ({ containerId }) => {
    const [showButton, setShowButton] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const hideTimeout = useRef(null); // Храним идентификатор таймера

    useEffect(() => {
        const container = document.getElementById(containerId);
        if (!container) return;

        const handleScroll = () => {
            if (container.scrollTop > 300) {
                setShowButton(true);
                setIsVisible(true); // Показываем кнопку

                // Если таймер на скрытие был запущен – отменяем его
                if (hideTimeout.current) {
                    clearTimeout(hideTimeout.current);
                    hideTimeout.current = null;
                }
            } else {
                setShowButton(false);

                // Очищаем предыдущий таймер перед запуском нового
                if (hideTimeout.current) {
                    clearTimeout(hideTimeout.current);
                }

                // Запускаем таймер на скрытие после 500 мс
                hideTimeout.current = setTimeout(() => {
                    setIsVisible(false);
                    hideTimeout.current = null;
                }, 500);
            }
        };

        container.addEventListener('scroll', handleScroll);
        return () => {
            container.removeEventListener('scroll', handleScroll);
            if (hideTimeout.current) clearTimeout(hideTimeout.current);
        };
    }, [containerId]);

    const scrollToTop = () => {
        const container = document.getElementById(containerId);
        if (container) {
            container.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    };

    return (
        <>
            {isVisible && (
                <Fab
                    color="inherit"
                    onClick={scrollToTop}
                    style={{
                        position: 'fixed',
                        bottom: '2rem',
                        right: '2rem',
                        zIndex: 1000,
                        animation: showButton ? 'fadeIn 0.5s ease-in-out' : 'fadeOut 0.5s ease-in-out',
                        opacity: showButton ? 1 : 0,
                        pointerEvents: showButton ? 'auto' : 'none',
                        transition: 'opacity 0.5s ease-in-out',
                    }}
                >
                    <ArrowBackIosNew sx={{ transform: 'rotate(90deg)' }} />
                </Fab>
            )}
                <style jsx="true">{`
                    @keyframes fadeIn {
                        from {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes fadeOut {
                        from {
                            opacity: 1;
                            transform: translateY(0);
                        }
                        to {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                    }
                `}</style>
        </>
    );
};
